import React from 'react';
import { Route, Switch } from 'react-router-dom';
import logo from './images/allosense_logo.png';
import settings from './settings';
import Map from './Map';
import Home from './Home';
import './App.css';

class App extends React.Component {
  render(){
    return ( 
      <div className="App">
        <header className="App-header">
          <img alt="Logo for Allosense" src={logo} />
          <p><span></span></p>
        </header>
          <Switch>
            <Route exact path="/">
              <section className="home-section">
                <Home />
              </section>
            </Route>
            <Route path="/:deviceId" render={props => {
              return (
                <section className="map-section">
                  <Map
                    { ...props }
                    mapboxToken= {settings.MAPBOX_TOKEN}
                    mapboxStyle= {settings.MAPBOX_STYLE}
                  />
                </section>
              ) 
            }} />
          </Switch>
      </div>
    );
  }
}

export default App;
